
/* BOTANICA PRODUCT CARD CAROUSEL */

(function () {
  function initCarousels(root = document) {
    root.querySelectorAll('[data-bc-carousel]').forEach(carousel => {
      if (carousel.dataset.bcReady === 'true') return;

      const track = carousel.querySelector('[data-bc-track]');
      const slides = [...carousel.querySelectorAll('[data-bc-slide]')];
      const prev = carousel.querySelector('[data-bc-prev]');
      const next = carousel.querySelector('[data-bc-next]');
      const dots = [...carousel.querySelectorAll('[data-bc-dot]')];

      if (!track || !slides.length) return;

      carousel.dataset.bcReady = 'true';

      let current = 0;
      let startX = 0;
      let startY = 0;
      let suppressClick = false;

      const productLink = carousel
        .closest('.card')
        ?.querySelector('.card__heading a[href]');

      function updateDots() {
        dots.forEach((dot, index) => {
          const active = index === current;
          dot.classList.toggle('is-active', active);

          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

function loadSlide(index) {
  const slide = slides[index];
  if (!slide) return;

  const image = slide.querySelector('img[data-bc-src]');
  if (!image) return;

  const src = image.dataset.bcSrc;
  const srcset = image.dataset.bcSrcset;

  if (srcset) {
    image.setAttribute('srcset', srcset);
  }

  if (src) {
    image.setAttribute('src', src);
  }

  image.removeAttribute('data-bc-src');
  image.removeAttribute('data-bc-srcset');
}

function goTo(index) {
  current = (index + slides.length) % slides.length;

  loadSlide(current);

  track.scrollTo({
    left: current * track.clientWidth,
    behavior: window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches ? 'auto' : 'smooth'
  });

  updateDots();
}

      // Previous image
      prev?.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        goTo(current - 1);
      });

      // Next image
      next?.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        goTo(current + 1);
      });

      // Pagination dots
      dots.forEach((dot, index) => {
        dot.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          goTo(index);
        });
      });

      // Keep dots synchronized with scrolling
      let scrollFrame;

      track.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);

        scrollFrame = requestAnimationFrame(() => {
          if (!track.clientWidth) return;

          current = Math.max(
            0,
            Math.min(
              slides.length - 1,
              Math.round(track.scrollLeft / track.clientWidth)
            )
          );

          loadSlide(current);
          updateDots();
        });
      }, { passive: true });
// Load neighbouring images when the customer begins swiping
carousel.addEventListener('touchstart', () => {
  loadSlide((current + 1) % slides.length);
  loadSlide((current - 1 + slides.length) % slides.length);
}, { passive: true });
      // Detect mobile swiping
      carousel.addEventListener('touchstart', event => {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        suppressClick = false;
      }, { passive: true });

      carousel.addEventListener('touchend', event => {
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;

        if (Math.abs(dx) > 15 && Math.abs(dx) > Math.abs(dy)) {
          suppressClick = true;

          setTimeout(() => {
            suppressClick = false;
          }, 350);
        }
      }, { passive: true });

      // Prevent a swipe from opening the product page
      carousel.addEventListener('click', event => {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        }
      }, true);

      // Clicking the image opens the product page
      carousel.addEventListener('click', event => {
        if (event.defaultPrevented) return;

        if (event.target.closest(
          '[data-bc-prev], [data-bc-next], [data-bc-dot], [data-bc-dots]'
        )) {
          return;
        }

        if (productLink) {
          window.location.href = productLink.href;
        }
      });

      updateDots();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCarousels();
    });
  } else {
    initCarousels();
  }

  document.addEventListener('shopify:section:load', event => {
    initCarousels(event.target);
  });

  const observer = new MutationObserver(() => initCarousels());

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
